<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="采购订单选择"
      width="1200px"
      top="5vh">
    <table-select
        ref="tableSelect"
        url="purchaseOrderDetails"
        module="basic"
        :filter="filter"
        :columns="columns"
        @select="selectPurchaseOrder"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter" label-width="95px" @keyup.enter.native="loadData()">
          <el-form-item label="采购单号">
            <el-input v-model.trim="filter.purchaseOrderNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: {TableSelect},
    data() {
      return {
        dialogVisible: false,
        filter: {
          purchaseOrderNo: "",
          salesOrderNo: "",
          supplierNo: "",
          supplierName: "",
          materialNo: "",
          materialName: "",
        },
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "采购单号",
            key: "purchaseOrderNo",
            align: "center",
            width: 180,
          },
          {
            title: "物料编号",
            key: "materialNo",
            width: 160,
          },
          {
            title: "物料描述",
            key: "materialName",
            minWidth: 240,
          },
          {
            title: "规格型号",
            key: "specification",
            minWidth: 180,
          },
          {
            title: "数量",
            key: "qty",
            width: 80,
            align: "center",
          },
          {
            title: "已送数量",
            key: "sendedQuantity",
            width: 100,
            align: "center",
          },
          {
            title: "交货日期",
            key: "deliveryDate",
            width: 120,
            align: "center",
            render: (h, params) => {
              return h(
                  "span",
                  params.row.deliveryDate ? params.row.deliveryDate.substring(0, 10) : "",
              );
            },
          },
          {
            title: "单位",
            key: "measuringUnitName",
            width: 80,
            align: "center",
          },
          {
            title: "供应商编号",
            key: "supplierNo",
            align: "center",
            width: 120,
          },
          {
            title: "供应商名称",
            key: "supplierName",
            width: 280,
            tooltip: true,
          },
          {
            title: "单价",
            key: "unitPrice",
            width: 80,
            align: "center",
          },
        ],
        selections: [],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.loadData();
        });
      },
      loadData() {
        this.$refs.tableSelect.loadData();
      },
      selectPurchaseOrder(selections) {
        this.selections = selections;
      },

      submitHandle() {
        this.$emit("select", this.selections);
        this.dialogVisible = false;
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>